import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAllOrders } from "../../hooks/orders"
import { Box, Checkbox } from "@chakra-ui/react"
import OrderPivot from "../../components/Orders/OrderPivot"
import Page from "../../components/Admin/Page"

const AdminOrdersPivotPage = () => {
  const { linkId } = useParams()
  const { orders, isLoading } = useAllOrders()
  const [currentOrders, setCurrentOrders] = useState([])
  const [showEmpty, setShowEmpty] = useState(false)

  useEffect(
    () =>
      setCurrentOrders([...orders.filter((item) => item.linkId === linkId)]),
    [orders, linkId]
  )

  return (
    <Page
      title="Riepilogo Verticale"
      back={`/admin/ordini/${linkId}`}
      isLoading={isLoading}
    >
      <Box p={4}>
        <Checkbox
          size="lg"
          colorScheme="teal"
          isChecked={showEmpty}
          onChange={(e) => setShowEmpty(e.target.checked)}
        >
          Mostra prodotti a zero
        </Checkbox>
      </Box>
      <OrderPivot items={currentOrders} showEmpty={showEmpty} />
    </Page>
  )
}

export default AdminOrdersPivotPage
